import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles/index';
import classNames from 'classnames';
import {
    Avatar,
    Button,
    Icon,
    IconButton,
    ListItemIcon,
    ListItemText,
    Popover,
    MenuItem,
    Typography,
    TableHead,
    TableCell,
    TableBody,
    Table,
    TableRow,
    Tooltip,
    FormGroup,
    FormControlLabel,
    Checkbox,
    Divider,
} from '@material-ui/core';
import { connect } from 'react-redux';
import * as authActions from 'auth/store/actions';
import * as quickPanelActions from 'main/quickPanel/store/actions';
import * as profileActions from './content/dashboard/store/actions/profile.actions';
import { bindActionCreators } from 'redux';
import { FuseAnimate } from '@fuse';
import moment from 'moment';
// import { Link, Redirect } from 'react-router-dom';


const styles = theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        width: '100%'
    },
    seperator: {
        width: 1,
        height: 64,
        backgroundColor: theme.palette.divider
    }
});

class MainToolbar extends Component {
    state = {
        userMenu: null,
        roleMenu: null,
        courseMenu: null,
        notificationMenu: null,
        instructorCourseMenu: null,
        show_finished_courses: false,
        show_ended_courses: false,
    };

    userMenuClick = event => {
        this.setState({ userMenu: event.currentTarget });
    };

    userMenuClose = () => {
        this.setState({ userMenu: null });
    };

    roleMenuClick = event => {
        this.setState({ roleMenu: event.currentTarget });
    };

    roleMenuClose = () => {
        this.setState({ roleMenu: null });
    };

    courseMenuClick = event => {
        this.setState({ courseMenu: event.currentTarget })
    }

    courseMenuClose = () => {
        this.setState({ courseMenu: null })
    }

    instructorCourseMenuClick = event => {
        this.setState({ instructorCourseMenu: event.currentTarget })
    }

    instructorCourseMenuClose = () => {
        this.setState({ instructorCourseMenu: null })
    }

    notificationMenuClick = event => {
        this.setState({ notificationMenu: event.currentTarget })
    }

    notificationMenuClose = () => {
        this.setState({ notificationMenu: null })
    }

    getStudentCourses = (user) => {
        if (user.role != 'student') {
            return null
        } else {
            const info = user.all_roles.filter(r => r.role_id === 4)[0]
            // return null
            if (info.link_info.ActiveCourses.length === 0) {
                return null
            }
            return info.link_info.ActiveCourses
        }
    }

    getInstructorCourses = (user) => {
        if (user.role != 'instructor') {
            return null
        }
        else {
            const info = user.all_roles.filter(r => r.role_id === 3 && r.Active === 1)[0]
            if (info.link_info.ActiveCourses.length === 0) {
                return null
            }
            return info.link_info.ActiveCourses
        }
    }

    handleMenuCheckbox = (event, checkbox_name) => {
        this.setState({
            [checkbox_name]: event.target.checked
        })
    }

    getRolesList = () => {
        if (!this.props.user || !this.props.user.all_roles) {
            return null
        }

        const roleDisplay = (role) => {
            if (role.role_id === 1 || role.role_id === 2 || role.role_id === 4) {
                return (
                    <MenuItem style={{ backgroundColor: role.Active === 1 ? '#DDDDDD' : 'white', marginTop: '5px', marginBottom: '5px' }}
                        onClick={() => this.props.toggleActiveAuthRole(role.auth_id, role.role_id, role.link_id, role.company_id)}
                    >
                        <ListItemText className="pl-0" primary={role.RoleName + (role.Active === 1 ? ' (Active)' : '')} />
                    </MenuItem>
                )
            }
            else if (role.role_id === 3 || role.role_id === 5) {
                return (
                    <MenuItem style={{ backgroundColor: role.Active === 1 ? '#DDDDDD' : 'white', marginTop: '5px', marginBottom: '5px' }}
                        onClick={() => this.props.toggleActiveAuthRole(role.auth_id, role.role_id, role.link_id, role.company_id)}
                    >
                        <ListItemText className="pl-0" primary={role.RoleName + (role.Active === 1 ? ' (Active)' : '')} secondary={role.link_info.CompanyName} />
                    </MenuItem>
                )
            }
        }

        const roles = this.props.user.all_roles.map(role => {
            return (
                roleDisplay(role)
            )

        })

        return (
            roles
        )

    }

    render() {
        const { classes, toggleQuickPanel, user, logout, profile, quick_panel_state, notifications } = this.props;
        const { userMenu, roleMenu, courseMenu, notificationMenu, instructorCourseMenu } = this.state;
        const studentCourses = this.getStudentCourses(user);
        const instructorCourses = this.getInstructorCourses(user);
        const roleList = this.getRolesList();

        const notificationMenuComponent = (prop) => {
            // console.log(notifications)
            if (prop) {
                return (
                    <Popover
                        open={Boolean(notificationMenu)}
                        anchorEl={notificationMenu}
                        onClose={this.notificationMenuClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center'
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center'
                        }}
                        classes={{
                            paper: "py-8"
                        }}
                    >
                        {notifications.map(notification => {
                            return (
                                <React.Fragment key={notification.notification_id}>
                                    <MenuItem
                                        onClick={() => {
                                            this.props.goToNotification(user.data.auth_id, notification)
                                            this.notificationMenuClose();
                                        }}
                                    >
                                        <ListItemIcon>
                                            {notification.Viewed === 0 ?
                                                <Icon>priority_high</Icon> :
                                                <Icon></Icon>
                                            }
                                        </ListItemIcon>
                                        <ListItemText className="pl-0" primary={notification.NotificationHeader} secondary={notification.ReferenceDisplay} />
                                    </MenuItem>
                                </React.Fragment>
                            )
                        })}

                    </Popover>
                )
            }
        }

        const roleMenuComponent = (prop) => {
            if (prop) {
                return (
                    <Popover
                        open={Boolean(roleMenu)}
                        anchorEl={roleMenu}
                        onClose={this.roleMenuClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center'
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center'
                        }}
                        classes={{
                            paper: "py-8"
                        }}
                    >
                        {roleList}
                    </Popover>
                )
            }
        }

        const instructorCourseMenuComponent = (prop) => {
            if (prop) {
                return (
                    <Popover
                        open={Boolean(instructorCourseMenu)}
                        anchorEl={instructorCourseMenu}
                        onClose={this.instructorCourseMenuClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center'
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center'
                        }}
                        classes={{
                            paper: "py-8"
                        }}
                    >
                        {instructorCourses.map(course => {
                            return (
                                <React.Fragment key={course.company_calendar_course_id}>
                                    <MenuItem
                                        onClick={() => {
                                            this.props.goToInstructorCourse(course.company_calendar_course_id, course.Unscheduled)
                                            this.instructorCourseMenuClose();
                                        }}
                                    >
                                        <ListItemIcon>
                                            <Icon>book</Icon>
                                        </ListItemIcon>
                                        <ListItemText className="pl-0" primary={course.CourseName} />
                                    </MenuItem>
                                </React.Fragment>
                            )
                        })}
                    </Popover>
                )
            }
        }

        const studentCourseMenuComponent = (prop) => {
            if (prop) {
                return (
                    <Popover
                        open={Boolean(courseMenu)}
                        anchorEl={courseMenu}
                        onClose={this.courseMenuClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center'
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center'
                        }}
                        classes={{
                            paper: "py-8"
                        }}
                    >
                        <React.Fragment>
                            <FormGroup row style={{ paddingLeft: '20px', paddingRight: '20px', display: 'flex', justifyContent: 'space-between' }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={this.state.show_finished_courses}
                                            onChange={(event) => this.handleMenuCheckbox(event, 'show_finished_courses')}
                                            color="primary"
                                        />
                                    }
                                    label="Show Completed Courses"
                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={this.state.show_ended_courses}
                                            onChange={(event) => this.handleMenuCheckbox(event, 'show_ended_courses')}
                                            color="primary"
                                        />
                                    }
                                    label="Show Ended Courses"
                                />
                            </FormGroup>
                            <Divider />
                            <Table>
                                <TableBody>
                                    {studentCourses
                                        .filter((course_info) => {
                                            if (!this.state.show_finished_courses && course_info.finished) {
                                                return false;
                                            }

                                            if (!this.state.show_ended_courses && !course_info.Unscheduled && moment() > moment(course_info.EndDate)) {
                                                return false;
                                            }

                                            return true;
                                        })
                                        .map((course_info, index) => {
                                            let course_status_icon = '';
                                            let course_date_range = '';
                                            let course_is_over = false;

                                            if (course_info.Unscheduled) {
                                                course_date_range = 'Self-Paced';
                                            } else {
                                                course_date_range = course_info.StartDate + " - " + course_info.EndDate;
                                                if (moment() > moment(course_info.EndDate)) {
                                                    course_is_over = true;
                                                }
                                            }

                                            if (course_info.finished) {
                                                course_status_icon = (
                                                    <Tooltip title={"Course Completed"}>
                                                        <Icon style={{ color: "green" }}>assignment_turned_in</Icon>
                                                    </Tooltip>
                                                )
                                            } else {
                                                if (course_is_over) {
                                                    course_status_icon = (
                                                        <Tooltip title={"Course has ended"}>
                                                            <Icon style={{ color: "red" }}>assignment_late</Icon>
                                                        </Tooltip>
                                                    )
                                                } else {
                                                    course_status_icon = (
                                                        <Tooltip title={"Course In Progress"}>
                                                            <Icon>assignment</Icon>
                                                        </Tooltip>
                                                    )
                                                }
                                            }

                                            return (
                                                <TableRow key={index}>
                                                    <TableCell>
                                                        {course_status_icon}
                                                    </TableCell>
                                                    <TableCell>{course_info.CourseName}</TableCell>
                                                    <TableCell>{course_date_range}</TableCell>
                                                    <TableCell>
                                                        <IconButton
                                                            onClick={() => {
                                                                this.props.goToCourse(course_info.company_calendar_course_id, course_info.Unscheduled)
                                                                this.courseMenuClose();
                                                            }}
                                                        >
                                                            <Icon>forward</Icon>
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        })}
                                </TableBody>
                            </Table>
                        </React.Fragment>
                    </Popover>
                )
            }
        }

        const displayRole = (role) => {
            if (role === 'instructor' || role === 'company') {
                return (
                    role + ' ' + '(' + user.data.role_info.CompanyName + ')'
                )
            }
            return role
        }

        if (user.Verified === 0) {
            return (
                <div></div>
            )
        }

        return (
            <div className={classNames(classes.root, "flex flex-row")}>
                <div className="flex flex-1" style={{ paddingLeft: '20px' }}>
                    <Typography variant="h6">

                    </Typography>
                </div>

                <div className="flex">

                    {studentCourses ?
                        <FuseAnimate delay={300}>
                            <Button className="h-64" onClick={this.courseMenuClick}>
                                Courses
                            </Button>
                        </FuseAnimate>
                        :
                        null
                    }

                    {instructorCourses ?
                        <FuseAnimate delay={300}>
                            <Button className="h-64" onClick={this.instructorCourseMenuClick}>
                                Courses
                            </Button>
                        </FuseAnimate>
                        :
                        null
                    }

                    {roleList ?
                        <FuseAnimate delay={300}>
                            <Button className="h-64" onClick={this.roleMenuClick}>
                                Roles
                            </Button>
                        </FuseAnimate>
                        :
                        null
                    }

                    <FuseAnimate delay={300}>
                        <Button className="h-64" onClick={this.userMenuClick}>
                            {user.data.photoURL ?
                                (
                                    <Avatar className="" alt="user photo" src={user.data.photoURL} />
                                )
                                :
                                (
                                    <Avatar className="">
                                        {user.data.displayName[0]}
                                    </Avatar>
                                )
                            }

                            <div className="hidden md:flex flex-col ml-12 items-start">
                                <Typography component="span" className="normal-case font-500 flex">
                                    {user.data.displayName}
                                </Typography>
                                <Typography className="text-11 capitalize" color="textSecondary">
                                    {displayRole(user.role)}
                                </Typography>
                            </div>

                            <Icon className="text-16 ml-12 hidden sm:flex" variant="action">keyboard_arrow_down</Icon>
                        </Button>
                    </FuseAnimate>

                    <Popover
                        open={Boolean(userMenu)}
                        anchorEl={userMenu}
                        onClose={this.userMenuClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center'
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center'
                        }}
                        classes={{
                            paper: "py-8"
                        }}
                    >
                        <React.Fragment>
                            <MenuItem
                                onClick={() => {
                                    logout();
                                    this.userMenuClose();
                                }}
                            >
                                <ListItemIcon>
                                    <Icon>exit_to_app</Icon>
                                </ListItemIcon>
                                <ListItemText className="pl-0" primary="Close App" />
                            </MenuItem>
                            <MenuItem
                                onClick={() => {
                                    profile();
                                    this.userMenuClose();
                                }}
                            >
                                <ListItemIcon>
                                    <Icon>account_box</Icon>
                                </ListItemIcon>
                                <ListItemText className="pl-0" primary="Profile" />
                            </MenuItem>
                        </React.Fragment>
                    </Popover>

                    <Popover
                        open={Boolean(userMenu)}
                        anchorEl={userMenu}
                        onClose={this.userMenuClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center'
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center'
                        }}
                        classes={{
                            paper: "py-8"
                        }}
                    >
                        <React.Fragment>
                            <MenuItem
                                onClick={() => {
                                    logout();
                                    this.userMenuClose();
                                }}
                            >
                                <ListItemIcon>
                                    <Icon>exit_to_app</Icon>
                                </ListItemIcon>
                                <ListItemText className="pl-0" primary="Close App" />
                            </MenuItem>
                            <MenuItem
                                onClick={() => {
                                    profile();
                                    this.userMenuClose();
                                }}
                            >
                                <ListItemIcon>
                                    <Icon>account_box</Icon>
                                </ListItemIcon>
                                <ListItemText className="pl-0" primary="Profile" />
                            </MenuItem>
                        </React.Fragment>
                    </Popover>

                    {notifications.length > 0 ?
                        <FuseAnimate delay={300}>
                            <Button className="h-64" onClick={this.notificationMenuClick}>
                                <Icon>notification_important</Icon>
                            </Button>
                        </FuseAnimate>
                        :
                        null
                    }

                    <div className={classes.seperator} />
                    {roleMenuComponent(Boolean(roleList))}
                    {notificationMenuComponent(!!notifications)}
                    {studentCourseMenuComponent(Boolean(studentCourses))}
                    {instructorCourseMenuComponent(Boolean(instructorCourses))}
                    <div className={classes.seperator} />

                    <IconButton className="w-64 h-64" onClick={() => toggleQuickPanel(quick_panel_state ? false : true)}>
                        <Icon>{quick_panel_state ? 'chevron_right' : 'chevron_left'}</Icon>
                    </IconButton>
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        toggleQuickPanel: quickPanelActions.toggleQuickPanel,
        logout: authActions.logoutUser,
        profile: authActions.goToProfile,
        goToCourse: authActions.goToCourse,
        goToInstructorCourse: authActions.goToInstructorCourse,
        goToNotification: authActions.goToNotification,
        toggleActiveAuthRole: profileActions.toggleActiveAuthRole,
    }, dispatch);
}

function mapStateToProps({ auth, quickPanel, notification }) {
    return {
        user: auth.user,
        quick_panel_state: quickPanel.state,
        notifications: notification.authNotifications
    }
}

export default withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(MainToolbar));



// WEBPACK FOOTER //
// src/main/MainToolbar.js